import { id, root } from './master-ecg';

export const masterEcg = {
  ...root,
  id,
};
